import { useParams } from 'react-router-dom';
import LazyLoad from 'react-lazyload';
import styled from 'styled-components';
import { useSelector } from 'react-redux';
import { AppCard, AppNoInfo } from '@/layout/AppComponents';
import ElementContainer from '../ElementContainer';
import colors from '../../../../../constants/colors';
import FilterBlock from '../FilterBlock';
import DocumentManagerPaginator from '../DocumentManagerPaginator';
import Breadcrumb from '../Breadcrumb';
import TopButtons from '../TopButtons';

export default function ListContainerView() {
  const { moduleBridgeHex, parentItemHex, page, filtersHex } = useParams();
  const permissionsLevel = useSelector(
    (s) => s.module[moduleBridgeHex]?.userBridge?.permissions?.level,
  );
  const loading = useSelector((state) => state.currentPage?.options?.loading);
  const pagination = useSelector((state) => state.currentPage?.pagination);
  const itemsPage = useSelector((state) => state.currentPage?.itemsPage);
  const itemsCurrentPage = useSelector(
    (state) => state.currentPage?.itemsPage?.[page - 1],
  );
  const moduleData = useSelector((s) => s?.module?.[moduleBridgeHex]?.moduleData);

  return (
    <Container>
      {moduleData && (
        <AppCard header="Consultar información">
          <FilterBlock />
          <TopButtons />
          {permissionsLevel === 0 && <Breadcrumb />}
          <div className="mt-3">
            {loading ? (
              <AppNoInfo iconSize={64} minHeight={window.innerHeight - 400} />
            ) : filtersHex === '0' &&
              permissionsLevel === 1 ? null : itemsCurrentPage === undefined ||
              itemsCurrentPage?.length === 0 ? (
              <div className="alert alert-light">
                Ingresar nueva información / No se han encontrado coincidencias
              </div>
            ) : (
              <>
                <TableHeader
                  $isAdminFiltering={filtersHex !== '0' && permissionsLevel === 0}
                >
                  <div>Nombre</div>
                  <div>Palabras clave</div>
                  {filtersHex !== '0' && permissionsLevel === 0 && <div>Ruta</div>}
                </TableHeader>
                {itemsCurrentPage?.map((id) => (
                  <LazyLoad key={id} height={50} className="item">
                    <ElementContainer view="list" elementID={id} />
                  </LazyLoad>
                ))}
                {itemsPage?.length > 0 && (
                  <DocumentManagerPaginator
                    pagination={pagination}
                    route="user_module_documentManager_item_list"
                    page={page}
                    pages={itemsPage}
                    className="mt-3"
                    params={{
                      moduleBridgeHex,
                      parentItemHex,
                      page,
                      filtersHex,
                    }}
                  />
                )}
              </>
            )}
          </div>
        </AppCard>
      )}
    </Container>
  );
}

const Container = styled.div`
  .item {
    &:hover {
      background-color: ${colors.grey200};
    }
  }
`;

const TableHeader = styled.div`
  position: -webkit-sticky;
  position: sticky;
  top: 40px;
  overflow: auto;
  background-color: #fff;
  border-bottom: solid 1px lightgrey;
  display: grid;
  grid-template-columns: ${(props) =>
    props.$isAdminFiltering ? '1fr 1fr 1fr 300px' : '1fr 1fr 300px'};
  padding-top: 8px;
  padding-bottom: 8px;

  div {
    font-weight: bold;
  }
`;
